import uniqueId from 'lodash/uniqueId'
import React from 'react'

const TypeStringArray = ({ value, customStyle = {} }) => {
  return (
    <div style={customStyle}>
      {value?.map(item => (
        <p key={uniqueId()} style={{ margin: '2px 0' }}>
          {item}
        </p>
      ))}
    </div>
  )
}
export default TypeStringArray
